/******************************************** IMPORTS *********************************************/
import {getLangFromUrlPathname} from 'mad-utils/lib/shared';
import {Country} from '@canimmunize/javelinscript';

const lang = getLangFromUrlPathname();

/**************************************** TYPE DEFINITIONS ****************************************/
type MultilangJsonData = Array<{en: string; fr: string; code: string}>;

/*************************************** DATAFILE CONSUMERS ***************************************/
/**
 * Get spoken language data objects array
 * Placeholder, this isn't in use currently
 */
const spokenLangsRaw = [{code: `eng`, en: `English`, fr: `anglais`}];

/**
 * Get country data objects array
 */
const countryDataRaw = require('../../../../../../i18n/country_codes.json') as MultilangJsonData;

/*************************************** DATA PREP EXPORTS ****************************************/
/**
 * Sort spoken_languages(.json) such that English and French are at the top,
 * followed by all other langs (which are listed alphabetically)
 * Import & parsing of spoken_languages.json into TS objects occurs in closure above
 */
export const spokenLangs = spokenLangsRaw.sort((langObj1, langObj2) => {
    if (langObj1.code === `eng` && langObj2.code === `fra`) return -1;
    if (langObj1.code === `fra` && langObj2.code === `eng`) return 1;

    if (langObj1.code === `eng`) return -1;
    if (langObj1.code === `fra`) return -1;

    if (langObj2.code === `eng`) return 1;
    if (langObj2.code === `fra`) return 1;

    if (langObj1[lang] > langObj2[lang]) return 1;
    if (langObj1[lang] === langObj2[lang]) return 0;
    if (langObj1[lang] < langObj2[lang]) return -1;
});

/**
 * Sort country_codes(.json) alphabetically
 * Eliminates `canada` as option
 * Import & parsing of country_codes.json into TS objects occurs in closure above
 */
export const countries = countryDataRaw
    .sort((countryObj1, countryObj2) => {
        if (countryObj1[lang] > countryObj2[lang]) return 1;
        if (countryObj1[lang] === countryObj2[lang]) return 0;
        if (countryObj1[lang] < countryObj2[lang]) return -1;
    })
    .filter(country => country.en.toLowerCase() !== `canada`);

/************************************** DATA MAPPING EXPORTS **************************************/
/**
 * Return country correpsonding to given country name or display
 */
export const getCountryFromName = (countryName: string) => {
    const country = countries.find(
        countryObj => countryObj[lang].toLowerCase() === countryName.toLowerCase()
    );
    return country ? new Country(country.code, country.en, country.fr) : null;
};
